export const styledConstants = {
    errorLabel: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: '0.75rem',
        color: 'red',
        letterSpacing: '0.03333em',
        lineHeight: '1.66',
        textAlign: 'center' as const,
        fontWeight: 400,
        marginTop: '0.25rem'
    },
    informationLabel: {
        margin: 0,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
        textAlign: 'center' as const,
    }
}